"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var themes_1 = require("../../themes");
exports.default = (0, styles_1.makeStyles)(function (theme) {
    return (0, styles_1.createStyles)({
        root: function (_a) {
            var border = _a.border, borderColor = _a.borderColor, value = _a.value, disabled = _a.disabled;
            return ({
                width: '100%',
                '& .MuiOutlinedInput-root': {
                    borderRadius: 8,
                    backgroundColor: '#fff',
                    height: '36px',
                    borderColor: borderColor,
                    color: value === '0' ? '#c5c8cb' : 'inherit',
                },
                '& .MuiInputBase-fullWidth': {
                    width: '100%',
                    height: 'inherit',
                },
                '& .MuiOutlinedInput-input': {
                    borderRadius: 8,
                    backgroundColor: disabled ? themes_1.materialColors.grey[100] : '#fff',
                    color: disabled ? themes_1.materialColors.grey[400] : 'inherit',
                    fontSize: '13px',
                    boxShadow: border === 'shadow' ? theme.shadows[1] : undefined,
                },
                '& .MuiOutlinedInput-notchedOutline': {
                    borderColor: border === 'outline' ? borderColor || theme.palette.primary.main : 'transparent',
                },
                // when used with options
                '& .MuiMenuItem-root': {
                    fontSize: '13px',
                },
                '& .MuiFormHelperText-outlined': {
                    marginLeft: 2,
                },
                '& .MuiFormHelperText-root.Mui-error': {
                    fontWeight: 700,
                },
                '& .MuiSelect-icon': {
                    color: themes_1.materialColors.blue[400],
                },
            });
        },
    });
});
